import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { Marker, Popup, useMap } from "react-map-gl";
import { useKey } from "../../Map/components/MapEventHandler/useKey";
import { siftActions, inputsActions, getBounds, getCenterPoint } from "../../Redux";
import { invisibleMarker } from "../../../assets/images";
import { Spinner } from "../../Spinner";
import { Radio } from "antd";

const MultiMapOffset = ({ feature_id }) => {
  const dispatch = useDispatch();

  const selectedFeatureId = useSelector((state) => state.inputs.selectedFeatureId);
  const show_offset_tool = useSelector((state) => state.sift.ioManager.uiState.show_offset_tool);
  const offsetType = useSelector((state) => state.inputs.offset_type);
  const site_features = useSelector((state) => state.inputs.site_features);

  const [offset_loading, set_offset_loading] = useState(false);
  const [menu_latlng, set_menu_latlng] = useState({ lat: undefined, lng: undefined });
  const [offset_distance, set_offset_distance] = useState(25);

  let offset_poly_hotkey = useKey("o"); // Hook for hotkey

  const { current: mapRef } = useMap();
  const map = mapRef.getMap();

  useEffect(() => {
    if (!map) return;
    map.on("toggleOffset", (e) => toggle_offset_polygon(e));
  }, [map]);

  const updateOffSetType = (event) => {
    dispatch(inputsActions.update_offset_type("offset_type", event.target.value));
  };

  //   useEffect(() => {
  //     if (show_offset_tool && selectedFeatureId && Array.isArray(selectedFeatureId) && Object.values(site_features).length >= 1) {
  //       let features = Object.values(site_features).filter((feature) => selectedFeatureId.includes(feature.properties.index));
  //       let center = getCenterPoint(features);
  //       console.log("Center", center);
  //       //   set_menu_latlng({ lat: center[0], lng: center[1] });
  //     }
  //   }, [show_offset_tool]);

  useEffect(() => {
    if (selectedFeatureId && Array.isArray(selectedFeatureId) && Object.values(site_features).length >= 1) {
      let features = Object.values(site_features).filter((feature) => selectedFeatureId.includes(feature.properties.index));
      let center = getCenterPoint(features);
      set_menu_latlng({ lat: center[0], lng: center[1] });
    }
  }, [selectedFeatureId]);

  useEffect(() => {
    console.log("menu_latlng", menu_latlng);
  }, [menu_latlng]);

  // Convert feet to meters
  function feetToMeters(feet) {
    return feet * 0.3048;
  }

  const offsetPolygon = (offsetDirection, saveOffset = false) => {
    let distance = offsetType === "ft" ? feetToMeters(offset_distance) : offset_distance;
    if (selectedFeatureId && Array.isArray(selectedFeatureId) && Object.values(site_features).length >= 1) {
      let features = Object.values(site_features).filter((feature) => selectedFeatureId.includes(feature.properties.index));
      console.log("distance - " + distance);
      console.log("features to offset", features);
      dispatch(siftActions.offsetPolygon(features, parseFloat(distance) * (offsetDirection === "inside" ? -1 : 1)));
    }

    set_offset_loading(false);
    set_offset_distance(25);
  };

  if (!selectedFeatureId && !Array.isArray(selectedFeatureId)) return;

  return (
    <>
      {show_offset_tool && selectedFeatureId && Array.isArray(selectedFeatureId) && menu_latlng.lat && menu_latlng.lng && (
        <Marker latitude={menu_latlng.lat} longitude={menu_latlng.lng} anchor="bottom">
          <img src={invisibleMarker} alt="Invisible Marker" />
          <Popup
            latitude={menu_latlng.lat}
            longitude={menu_latlng.lng}
            closeButton={true}
            onClose={() => dispatch(siftActions.updateUIState("show_offset_tool", false))}
            onOpen={() => console.log("Popup opened")}
          >
            <section className="offset-tool" style={{ width: 275 }}>
              <div className="offset-tool-close">
                {offset_loading && (
                  <div className="offset-loading">
                    <p>Loading</p>
                    <Spinner color={"var(--primary-brand-color)"} />
                  </div>
                )}
              </div>
              <div className="offset-tool-input">
                <label>Offset Distance </label>
                <Radio.Group buttonStyle="solid" size="small" value={offsetType} onChange={updateOffSetType}>
                  <Radio.Button key="feet" value="ft" className="offset-tool-button">
                    ft
                  </Radio.Button>
                  <Radio.Button key="meter" value="m" className="offset-tool-button">
                    m
                  </Radio.Button>
                </Radio.Group>
              </div>

              <div className="offset-tool-controls">
                <input
                  //   style={{ outlineColor: "var(--primary-brand-color", width: 134 }}
                  type="number"
                  step="1"
                  value={offset_distance}
                  onClick={(e) => e.stopPropagation()}
                  onChange={(e) => set_offset_distance(e.target.value)}
                />

                <section className="offset-tool-buttons">
                  <button onClick={() => offsetPolygon("inside", true)}>Inside</button>
                  <button onClick={() => offsetPolygon("outside", true)}>Outside</button>
                </section>
              </div>
            </section>
          </Popup>
        </Marker>
      )}
    </>
  );
};

export { MultiMapOffset };
